export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const FETCH_ALL = 'FETCH_ALL';
export const DELETE = 'DELETE';
export const LIKE = 'LIKE';